import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody, Row, Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import Moment from "moment";


const modeloDatos = {
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 0,
    nombreCliente: "",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    fecha: new Date,
    comentario: "",
    estatus: 0,
    facturado:true,
}
const modeloDatos1 = {
   
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    noFactura:"",
    clienteID: 0,
    nombreCliente: "",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    telefono:"",
    fecha: new Date,
    comentario: "",
    facturado: false,
    estatus: 0,

    efectivo: 0.00,
    tarjeta: 0.00,
    transferencia: 0.00,
    cheque: 0.00,
    totalPago:0.00,
    devolucion:0.00

}

let options = [];
let options1 = [];
let Total = 0;
let Pago = 0;
const Venta = () => {
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))

    const [tabla, setTabla] = useState(modeloDatos);
    const [tabla2, setTabla2] = useState(modeloDatos1);
    const [Listado, SetListado] = useState([]);
    const [ListadoLineas, SetListadoLineas] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [ListadoArticulos, SetListadoArticulos] = useState([]);
    const [ListadoClientes, SetListadoClientes] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [verModalPago, setVerModalPago] = useState(false);
    const [busqueda, setbusqueda] = useState("");

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        console.log(e);
        var searchData = l.filter((item) => {
            if (
                (item.descripcion)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };
    let correo = JSON.parse(user).correo;


    const handleChange = (e) => {
        
        setTabla2({
            ...tabla2,
            [e.target.name]: e.target.value
        })
        }



   
        const handleChange2 = (e) => {
            setTabla({
                ...tabla,
                ["clienteID"]: e.value, ["nombreCliente"]: e.nombre, ["rnc"]: e.rnc
            })
    }

    //Proceso de pago factura
    const ProcesarPago = async () => {
        tabla2.pedidoID = tabla.pedidoID;
        tabla2.efectivo = parseFloat(tabla2.efectivo);
        tabla2.tarjeta = parseFloat(tabla2.tarjeta);
        tabla2.cheque = parseFloat(tabla2.cheque);
        tabla2.transferencia = parseFloat(tabla2.transferencia);
        tabla2.devolucion = ((parseFloat(tabla2.efectivo) +
            parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
            + parseFloat(tabla2.cheque)) - Total);

        let response = await fetch(Api + "VentasTrans/ProcesarFactura", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(tabla2)
        })
        if (response.ok) {

            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
            setVerModalPago(false);
        }
    }


    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasTrans/listaPedidoVentas");
        if (response.ok) {
            let data1 = await response.json()
            let data = data1.filter(x => x.estatus >=1).map(x =>x) 
            SetListado1(data)
            if (pendiente) {
                SetListado(data)
                setPendiente(false)
            }
        }
    }
    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoVentasLineas/"+pl);
        if (response.ok) {
            let data = await response.json()
            SetListadoLineas(data)

            Total = data.reduce((x, y) => {
                return  x + (y.precio * y.cantidad);
            }, 0);
            setTabla2({
                ...tabla2,
                totalPago:  Total
            })
        }
    }
const obtenerDatosArticulas = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaArticulos");

        if (response.ok) {
            let data = await response.json()
            SetListadoArticulos(data)
            data.filter(x => x.activo == true).map(x => {
                options1.push({
                    value: x.articuloID, label: x.articuloID + "-" + x.descripcion, nombre: x.descripcion,
                    almacenID: x.almacenPorDefecto, costo: x.costoPromedio, precio: x.precioPromedio, Cant_min: x.cantidadMinima, cambiarDescripcion: x.cambiarDescripcion
                    , cambiarPrecio: x.cambiarPrecio
                })
            })
        }
    }

    const obtenerDatosClientes = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaClientes");

        if (response.ok) {
            let data = await response.json()
            SetListadoClientes(data)
            data.map(x => {
                options.push({ value: x.clienteID, label: x.rnc + "-" + x.descripcion, nombre: x.descripcion, rnc:x.rnc })
            })
        }
    }


    useEffect(() => {
        obtenerDatos();
    })
    useEffect(() => {
        obtenerDatosArticulas();
        obtenerDatosClientes()
    }, [])


    const abrirEditarModal = (data) => {
        setTabla(data);

        //// Aqui va el llenado par ala factura
       
            tabla2.pedidoID= data.pedidoID; tabla2. empresaID= data.empresaID; tabla2. numeroUnico= data.numeroUnico; tabla2.
            clienteID= data.clienteID; tabla2. nombreCliente= data.nombreCliente; tabla2. rnc= data.rnc; tabla2.
            tipoComprobante= data.tipoComprobante; tabla2. ncf= data.ncf; tabla2. fecha= new Date; tabla2.
            comentario= data.comentario; tabla2. estatus= data.estatus
       


        setVerModal(!verModal);
        obtenerDatosLineas(data.pedidoID);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.pedidoID,
            sortable: true,
        },
        {
            name: 'Descripcion',
            selector: row => row.nombreCliente,
            sortable: true,
        },

       
        {
            name: '',
            cell: row => (
                <>
                    <Button hidden={tabla.estatus >= 1} color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>




                </>
            ),
        },
    ];

const columns1 = [
        {
            name: 'Orden',
            selector: row => row.articuloID,
        
        },
        {
            name: 'Descripcion',
            selector: row => row.descripcionArticulo,
          
        },  {
            name: 'Cantidad',
            selector: row => row.cantidad
        },{
            name: 'Precio',
            selector: row => row.precio
        },{
            name: 'Total',
            selector: row => row.precio * row.cantidad,
          
        },

    
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

   

    return (
        <>


            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Facturacion
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md={4}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar  " ></Input> </Col>
                    </Row>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        //pagination
                        //paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    Mantenimiento de Articulos
                </ModalHeader>
                <ModalBody>
                    <Row>
                        
                        <Col md={3}>
                            <FormGroup hidden>

                                <Label>ClienteID</Label>
                                {/*<Input bsSize="sm" name="clienteID" onChange={handleChange} value={tabla.clienteID} />*/}

                                <Select
                                 
                                    name={"clienteID"}
                                    onChange={handleChange2}
                                    defaultValue={options.filter(x => x.value == tabla.clienteID)[0]}
                                    options={options}
                                />
                            </FormGroup></Col>           
                    
                           <Col md={3} >
                            <FormGroup>

                                <Label>RNC</Label>
                                <Input disabled={tabla.clienteID != 1} bsSize="sm" name="rnc"  value={tabla.rnc} />
                            </FormGroup></Col>
                        <Col md={6}>
                            <FormGroup>

                                <Label>Nombre Cliente</Label>
                                <Input disabled={tabla.clienteID != 1} bsSize="sm" name="nombreCliente"  value={tabla.nombreCliente} />
                            </FormGroup></Col>

                        <Col md={3} >
                            <FormGroup>

                                <Label>Comprobante</Label>
                                <Input disabled bsSize="sm" name="tipoComprobante"  value={tabla.tipoComprobante} />
                            </FormGroup></Col>
                        <Col md={3} >
                            <FormGroup>

                                <Label>NCF</Label>
                                <Input disabled bsSize="sm" name="ncf"  value={tabla.ncf} />
                            </FormGroup></Col>
                      
                        <Col md={3} >
                            <FormGroup>

                                <Label>Telefono</Label>
                                <Input disabled bsSize="sm" name="telefono"  value={tabla.telefono} />
                            </FormGroup></Col>
                        <Col md={3} >
                            <FormGroup>

                                <Label>Estatus</Label>
                                <Input disabled bsSize="sm"   value={tabla.facturado} />
                            </FormGroup></Col>

                        <Col md={3} >
                            <FormGroup>

                                <Label>Fecha</Label>
                                <Input disabled bsSize="sm" type="date" name="fecha"  value={Moment(tabla.fecha).format('YYYY-MM-DD') } />
                            </FormGroup></Col>

                        <Col md={12} >
                            <FormGroup>

                                <Label>Comentario</Label>
                                <Input disabled bsSize="sm" type="textarea" name="comentario"  value={tabla.comentario} />
                            </FormGroup></Col>
                      
                    </Row>
                    <br />
                    <div hidden={tabla.pedidoID == 0 }>
                  
                        <Row>
                            <DataTable
                                columns={columns1}
                                data={ListadoLineas}
                                customStyles={customStyles}
                            />
                                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {Total }
                    <Button size="sm" color="success"
                        onClick={()=>setVerModalPago(!verModalPago)}
                    >Pagar</Button>

                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            <Modal isOpen={verModalPago} >
                <ModalHeader className="modal-header1">
                    Cobrando a: {tabla.nombreCliente }
                </ModalHeader>
                <ModalBody>
                    {Total}
                    <Col md={3} >
                        <FormGroup>

                            <Label>Efetivo</Label>
                            <Input bsSize="sm" type="number" name="efectivo" onChange={handleChange} value={tabla2.efectivo} />
                        </FormGroup></Col>
                    <Col md={3} >
                        <FormGroup>

                            <Label>Tarjeta</Label>
                            <Input bsSize="sm" type="number"  name="tarjeta" onChange={handleChange} value={tabla2.tarjeta} />
                        </FormGroup></Col>
                    <Col md={3} >
                        <FormGroup>

                            <Label>Transferencia</Label>
                            <Input bsSize="sm" type="number"  name="transferencia" onChange={handleChange} value={tabla2.transferencia} />
                        </FormGroup></Col>
                    <Col md={3} >
                        <FormGroup>

                            <Label>Cheque</Label>
                            <Input bsSize="sm" name="cheque" onChange={handleChange} value={tabla2.cheque} />
                        </FormGroup></Col>
                    Devuelta: {(parseFloat(tabla2.efectivo) + parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia) + parseFloat(tabla2.cheque)) - Total}
                </ModalBody>
                <ModalFooter>

                   

                    <Button hidden={tabla.facturado } size="sm" color="success"
                        onClick={() => ProcesarPago()}

                    >Pagar {tabla.facturado}</Button>
                    <Button size="sm" color="danger"
                        onClick={() => setVerModalPago(false)}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>





        </>
    )

}
export default Venta;